import { combineReducers } from 'redux';
import affordabilityCommonReducer from './AffordabilityProgram/AffordabilityCommonReducer';
import ddpServiceReducer from './AffordabilityProgram/DDPReducer';
import ImagingReducer from './Ancillary/ImagingReducer';
import LabsReducer from './Ancillary/LabsReducer';
import CallsPageReducer from './CallsPageReducer/CallsPageReducer';
import commonReducer from './common/common.reducer';
import filterReducer from './customeHooksReducers/quickFilterReducer';
import TableReducer from './genericComponentsReducers/tableReducer';
import GlobalFilterReducer from './GlobalFilter/GlobalFilterReducer';
import HiVolumeTinsReducer from './HiVolumeTinsReducers/HiVolumeTinsReducer';
import indicatorReducer from './IndicatorReducer';
import MyInsightsReducer from './MyInsightsReducer';
import valueBasedContractingReducer from './NetworkManagementReducer/VBC/ValueBasedContractingReducer';
import notificationBannerReducer from './NotificationBannerReducer';
import OverviewReducer from './OverviewReducer';
import FaqReducer from './Faq/faqReducer';
import PsmsDigitalAdoptionReducer from './psms/DigitalAdoption/DigitalAdoptionReducer';
import PCORReducer from './PCOR/pcorReducer';
import pnbReducer from './pnbProgram/pnsReducer';
import PriorAuthReducer from './PriorAuth/PriorAuthReducer';
import ProviderExperienceReducer from './ProviderExperienceReducer';
import PemDetailsReducer from './PEM/PemDetailsReducer';
import providerSearchReducer from './ProviderSearch/ProviderSearchReducer';
import accountsReceivableReducer from './psms/AccountsReceivable/accountsReceivableReducer';
import callsChatsReducer from './psms/callsChatsReducer';
import psmsClaimsReducer from './psms/ClaimsReducer/claimsReducer';
import psmsPAReducer from './psms/PAReducer/psmsPAReducer';
import PsmsPaymentIntegrityReducer from './psms/PaymentIntegrity/PsmsPaymentIntegrityReducer';
import psmsReducer from './psms/psmsReducer';
import psmsViewTaxIdReducer from './psms/ViewTaxIdReducer/viewTaxIdReducer';
import AppealReducer from './Reimbursement/Appeal/AppealReducer';
import ClaimsProcessedReducer from './Reimbursement/ClaimsProcessed/ClaimsProcessedReducer';
import NonPaymentReducer from './Reimbursement/NonPayment/NonPaymentReducer';
import OverpaymentReducer from './Reimbursement/OverPayment/OverpaymentReducer';
import PaymentIntegrityReducer from './Reimbursement/PaymentIntegrity/PaymentIntegrityReducer';
import PaymentIntegrityDetailsReducer from './Reimbursement/PaymentIntegrityDetails/PaymentIntegrityDetailsReducer';
import PaymentsReducer from './Reimbursement/Payments/PaymentsReducer';
import ReconsiderationReducer from './Reimbursement/Reconsideration/ReconsiderationReducer';
import ReiumbursementTabsReducer from './Reimbursement/ReimbursementTabs/ReiumbursementTabsReducer';
import SettlementReducer from './Reimbursement/Settlement/SettlementReducer';
import EditfilterReducer from './ServiceInteraction/DigitalSummary/EdiFilter/EDIFilterReducer';
import PreCheckMyScriptReducer from './ServiceInteraction/DigitalSummary/PreCheckMyScript/PreCheckMyScriptReducer';
import SmartEditGeoFilterReducer from './ServiceInteraction/DigitalSummary/SmartEditGeoFilter/SmartEditGeoFilterReducer';
import SmartEditsReducer from './ServiceInteraction/DigitalSummary/SmartEdits/SmartEditsReducer';
import siteOfServiceReducer from './SiteOfServiceReducer';
import surestReducer from './Surest/surestReducer';
import AdvanceSearchReducer from './AdvanceSearch/AdvanceSearchReducer';
import homePageReducer from './HomePage/HomePageReducer';
import ImpactReducer from './Impact/impactReducer';
import ClaimsReportingReducer from './ClaimsReporting/claimsReportingReducer';
import pemSummaryReducer from './PEM/PEMSummaryReducer';
import croReducer from '@src/apps/NetworkManagement/ContractRemediationOpportunities/croRedux';

const rootReducer = combineReducers({
  sosReducer: siteOfServiceReducer,
  indicatorReducer: indicatorReducer,
  ddpReducer: ddpServiceReducer,
  valueBasedContractingReducer: valueBasedContractingReducer,
  affordabililityData: affordabilityCommonReducer,
  pnsStrategyData: pnbReducer,
  paymentIntegrityReducer: PaymentIntegrityReducer,
  providerSearchReducer: providerSearchReducer,
  imagingReducer: ImagingReducer,
  ProviderExperienceReducer: ProviderExperienceReducer,
  PemDetailsReducer: PemDetailsReducer,
  OverpaymentReducer: OverpaymentReducer,
  filterReducer: filterReducer,
  sharedState: commonReducer,
  priorAuthReducer: PriorAuthReducer,
  tableReducer: TableReducer,
  globalFilterReducer: GlobalFilterReducer,
  HiVolumeTinsReducer: HiVolumeTinsReducer,
  paymentIntegrityDetailsReducer: PaymentIntegrityDetailsReducer,
  appealReducer: AppealReducer,
  ReconsiderationReducer: ReconsiderationReducer,
  NonPaymentReducer: NonPaymentReducer,
  paymentsReducer: PaymentsReducer,
  claimsProcessedReducer: ClaimsProcessedReducer,
  surestReducer: surestReducer,
  smartEditsReducer: SmartEditsReducer,
  pcorReducer: PCORReducer,
  notificationBannerReducer: notificationBannerReducer,
  LabsReducer: LabsReducer,
  callsPageReducer: CallsPageReducer,
  SettlementReducer: SettlementReducer,
  MyInsightsReducer: MyInsightsReducer,
  PreCheckMyScriptReducer: PreCheckMyScriptReducer,
  ReiumbursementTabsReducer: ReiumbursementTabsReducer,
  EdiFilterReducer: EditfilterReducer,
  OverviewReducer: OverviewReducer,
  FaqReducer: FaqReducer,
  SmartEditGeoFilterReducer: SmartEditGeoFilterReducer,
  PsmsPaymentIntegrityReducer: PsmsPaymentIntegrityReducer,
  PsmsDigitalAdoptionReducer: PsmsDigitalAdoptionReducer,
  psmsReducer: psmsReducer,
  psmsClaimsReducer: psmsClaimsReducer,
  psmsViewTaxIdReducer: psmsViewTaxIdReducer,
  accountsReceivableReducer: accountsReceivableReducer,
  callsChatsReducer: callsChatsReducer,
  psmsPAReducer: psmsPAReducer,
  advanceSearchReducer: AdvanceSearchReducer,
  homePageReducer: homePageReducer,
  impactReducer: ImpactReducer,
  claimsReportingReducer: ClaimsReportingReducer,
  pemSummaryReducer: pemSummaryReducer,
  croReducer: croReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
